(function () {
  function htmlDecode(input) {
    var doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
  }

  let wishlistTranslation = {},
    usfTranslations = {};
  if (window.swym_translations) {
    window.swymTranslation = window.swymTranslation || {};
    Object.assign(
      window.swymTranslation,
      JSON.parse(htmlDecode(window.swym_translations.innerHTML))
    );
  }
  if (window.wishlist_translations) {
    wishlistTranslation = JSON.parse(
      htmlDecode(window.wishlist_translations.innerHTML)
    );
  }
  if (window.usf_filter_translations) {
    usfTranslations = JSON.parse(
      htmlDecode(window.usf_filter_translations.innerHTML)
    );
  }

  if (window.js_cart_translations) {
    window.jsCartTranslations = window.jsCartTranslations || {};
    Object.assign(
      window.jsCartTranslations,
      JSON.parse(htmlDecode(window.js_cart_translations.innerHTML))
    );
  }

  const wishlistAnchor =
    'v-html="_usfAddToCartText"></span>\n                  </span>\n              </button>\n';
  const wishlist = `
  <!-- Swym Wishlist Plus Button-->
  <button type="button"
          title="${wishlistTranslation.add_to_wishlist}"
          class="text-link swym-button swym-add-to-wishlist-view-product quick-add-btn"
          data-with-epi="true"
          :class="'product_' + product.id"
          data-swaction="addToWishlist"
          :data-product-id="product.id"
          :data-variant-id="product.variants[0].id"
          :data-product-url="window.wave._wcSwym(product, productUrl)">
    <span class="btn btn--circle btn--icon">
      <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-heart" viewBox="0 0 64 64"><defs><style>.a{fill:none;stroke:#000;stroke-width:2px}</style></defs><path class="a" d="M51.27 15.05a13 13 0 0 0-18.44 0l-.83.83-.83-.83a13 13 0 0 0-18.44 18.44l.83.83L32 52.77l18.44-18.45.83-.83a13 13 0 0 0 0-18.44z"/></svg>
      <span class="icon__fallback-text">${wishlistTranslation.add_to_wishlist}</span>
    </span>
  </button>
  <!-- Swym Wishlist Plus Button-->
  `;
  const actionAnchor = "      <!--actions -->\n";
  const badges = `
  <div class="grid-product__badges grid-product__badges--left">
    <template v-for="metafield in product.metafields" :key="metafield.key">
      <div style="padding-top:0px;" v-if="metafield.key == 'p_awards' && metafield.value == '1'">
        <img src="https://cdn.shopify.com/s/files/1/0465/3167/4278/files/20201009_JFW_Website-Revamp_Icons-for-products_Award_EN.png?v=1603103772"/>
      </div>
      <div style="padding-top:0px;" v-if="metafield.key == 'p_buddys_pick' && metafield.value == '1'" >
        <img src="https://cdn.shopify.com/s/files/1/0465/3167/4278/files/20201009_JFW_Website-Revamp_Icons-for-products_BuddysPick_EN.png?v=1603103772"/>
      </div>
      <div style="padding-top:0px;" v-if="metafield.key == 'p_new_arrival' && metafield.value == '1'">
        <img src="https://cdn.shopify.com/s/files/1/0465/3167/4278/files/20201009_JFW_Website-Revamp_Icons-for-products_NewArrival_EN.png?v=1603103772"/>
      </div>
      <div style="padding-top:0px;"  v-if="metafield.key == 'p_hot_items' && metafield.value == '1'">
        <img src="https://cdn.shopify.com/s/files/1/0465/3167/4278/files/20201009_JFW_Website-Revamp_Icons-for-products_HotItem_EN.png?v=1603103772"/>
      </div>
      <div style="padding-top:0px;"  v-if="metafield.key == 'p_hero_products' && metafield.value == '1'">
        <img src="https://cdn.shopify.com/s/files/1/0465/3167/4278/files/20201009_JFW_Website-Revamp_Icons-for-products_HeroProduct_EN.png?v=1603103773"/>
      </div>
    </template>
  </div>`;
  const swatchesAnchor = "                    <!-- Swatchs-->\n";
  const rating = `
  <div class="rating-meta-fields rating-meta-fields--small">
    <div class="price__badges--listing">
      <div class="res-wrapper">
        <div class="res-tit-note">
          <template v-for="metafield in window.wave.reducedMetafields(product.metafields)" :key="metafield.key" class="res-tit-note__list">
              <span v-if="metafield.key == 'n_rating_robert_parker' && metafield.value"><span class="res-notefirst">RP</span><span class="res-notesecond">\{\{ metafield.value }}</span></span>
              <span v-if="metafield.key == 'n_rating_james_suckling' && metafield.value"><span class="res-notefirst">JS</span><span class="res-notesecond">\{\{ metafield.value }}</span></span>
              <span v-if="metafield.key == 'n_rating_james_halliday' && metafield.value"><span class="res-notefirst">JH</span><span class="res-notesecond">\{\{ metafield.value }}</span></span>
              <span v-if="metafield.key == 'n_rating_wine_spectator' && metafield.value"><span class="res-notefirst">WS</span><span class="res-notesecond">\{\{ metafield.value }}</span></span>
              <span v-if="metafield.key == 'n_rating_jancis_robinson' && metafield.value"><span class="res-notefirst">JR</span><span class="res-notesecond">\{\{ metafield.value }}</span></span>
              <span v-if="metafield.key == 'n_rating_wine_enthusiast' && metafield.value"><span class="res-notefirst">WE</span><span class="res-notesecond">\{\{ metafield.value }}</span></span>
          </template>
        </div>
      </div>
    </div>
  </div>`;

  const ratingKeys = [
    "n_rating_james_halliday",
    "n_rating_jancis_robinson",
    "n_rating_james_suckling",
    "n_rating_robert_parker",
    "n_rating_wine_enthusiast",
    "n_rating_wine_spectator",
  ];
  function reducedMetafields(metafields) {
    const newMetafields = metafields
      .filter(({ key }) => {
        return ratingKeys.includes(key);
      })
      .sort((a, b) => {
        return ratingKeys.indexOf(a.key) - ratingKeys.indexOf(b.key);
      })
      .slice(0, 3);
    return newMetafields;
  }

  const gridAnchors = [
    {
      src: wishlistAnchor,
      target: wishlistAnchor + wishlist,
    },
    {
      src: actionAnchor,
      target: actionAnchor + badges,
    },
    {
      src: swatchesAnchor,
      target: rating + swatchesAnchor,
    },
  ];
  const filtersBreadcrumbAnchors = [
    {
      src: 'v-html="facet.title',
      target: 'v-html="window.wave._usfGetFacetTitleTran(facet.title)',
    },
    {
      src: 'v-html="root.formatBreadcrumbLabel(facet, f[0], queryValStr)"',
      target:
        'v-html="window.wave._usfGetFacetValueLabelTran(facet.title,root.formatBreadcrumbLabel(facet, f[0], queryValStr))"',
    },
  ];

  const filtersAnchors = [
    {
      src: 'v-html="facets[0].title',
      target: 'v-html="window.wave._usfGetFacetTitleTran(facets[0].title)',
    },
    {
      src: 'v-html="mobileSelectedFacet.title"',
      target:
        'v-html="window.wave._usfGetFacetTitleTran(mobileSelectedFacet.title)"',
    },
    {
      src: 'v-html="f.title"',
      target: 'v-html="window.wave._usfGetFacetTitleTran(f.title)"',
    },
  ];

  const filterAnchors = [
    {
      src: 'v-html="facet.title"',
      target: 'v-html="window.wave._usfGetFacetTitleTran(facet.title)"',
    },
  ];

  const filterOptionAnchors = [
    {
      src: 'v-html="label"',
      target:
        'v-html="window.wave._usfGetFacetValueLabelTran(facet.title,label)"',
    },
    {
      src: "option.label",
      target:
        "window.wave._usfGetFacetValueLabelTran(facet.title,option.label)",
    },
  ];
  const usfReplacer = function (usf) {
    usf.event.add("init", function () {
      usf.settings.translation = usf.settings.translation || {};
      Object.assign(usf.settings.translation, usfTranslations.native || {});
    });
    usf.event.add("sr_updated", function ($event) {
      document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
    });

    usf.templates.searchResultsGridViewItem = gridAnchors.reduce(
      (f, { src, target }) => {
        return f.replaceAll(src, target);
      },
      usf.templates.searchResultsGridViewItem
    );
    usf.templates.filtersBreadcrumb = filtersBreadcrumbAnchors.reduce(
      (f, { src, target }) => {
        return f.replaceAll(src, target);
      },
      usf.templates.filtersBreadcrumb
    );
    usf.templates.filters = filtersAnchors.reduce((f, { src, target }) => {
      return f.replaceAll(src, target);
    }, usf.templates.filters);
    usf.templates.filter = filterAnchors.reduce((f, { src, target }) => {
      return f.replaceAll(src, target);
    }, usf.templates.filter);
    usf.templates.filterOption = filterOptionAnchors.reduce(
      (f, { src, target }) => {
        return f.replaceAll(src, target);
      },
      usf.templates.filterOption
    );
  };

  function _wcSwym(product, productUrl) {
    var fullProductUrl = new URL(productUrl, window.location.href).href;
    ["SwymViewProducts", "SwymWatchProducts", "SwymProductVariants"].forEach(
      function (k) {
        if (!window[k]) window[k] = {};
      }
    );
    var collections = product.productType;
    var o = {},
      empi = product.id,
      piu;
    if (product.images && product.images.length > 0) {
      piu = product.images.url;
    }
    var currentVariant, currentVariantData;
    if (product.variants) {
      for (var i = 0; i < product.variants.length; i++) {
        var variant = product.variants[i];
        if (variant.imageIndex > -1) {
          console.log("Please contact wave support for further improvements.");
        }
        var vid = variant.id;
        var v = {
          empi: empi,
          epi: vid,
          du: fullProductUrl,
          dt: product.title,
          ct: collections,
          iu: piu,
          stk: variant.available,
          pr: variant.price,
          variants: [{ [variant.title]: vid }],
        };
        if (variant.compareAtPrice) {
          v["op"] = variant.compareAtPrice;
        }
        if (!currentVariant || product.selectedVariantId === variant.id) {
          currentVariant = variant;
          currentVariantData = v;
        }
        SwymProductVariants[vid] = v;
      }
    }
    var pid = product.id;
    SwymViewProducts[product.handle] = SwymViewProducts[pid] =
      currentVariantData;
    SwymWatchProducts[product.handle] = SwymWatchProducts[pid] = o;

    return fullProductUrl;
  }

  const keyHandle = function (l) {
    return l
      ? l
          .toLowerCase()
          .replace(/[\s\/]/g, "_")
          .replace(/---/g, "_")
          .replace(/--/g, "_")
          .replace(/&/g, "_")
          .replace(/\(/g, "_")
          .replace(/\)/g, "_")
          .replace(/\+/g, "_")
          .replace(/amp;/g, "")
          .replace(/,/g, "_")
          .replace(/'/g, "_")
          .replace(/™/g, "_")
          .replace(/\./g, "_")
          .replace(/ö/g, "o")
          .replace(/ß/g, "b")
          .replace(/ü/g, "u")

          .replace(/ä/g, "a")
          .replace(/á/g, "a")
          .replace(/â/g, "a")
          .replace(/%/g, "percent")
          .replace(/è/g, "e")
          .replace(/ê/g, "e")
          .replace(/\?/g, "_")
          .replace(/€/g, "_")
      : "";
  };
  function _usfGetFacetTitleTran(title) {
    if (!usfTranslations) return title;

    var key = keyHandle(title);
    if (usfTranslations[key]) return usfTranslations[key].label;
    else return title;
  }

  function _usfGetFacetValueLabelTran(facetTitle, valueLabel) {
    if (!usfTranslations) return valueLabel;

    var facetKey = keyHandle(facetTitle);
    var valueKey = keyHandle(valueLabel);
    if (
      usfTranslations[facetKey] &&
      usfTranslations[facetKey].value &&
      usfTranslations[facetKey].value[valueKey]
    )
      return usfTranslations[facetKey].value[valueKey];
    else return valueLabel;
  }

  window.wave = window.wave || {};
  Object.assign(window.wave, {
    usfReplacer: usfReplacer,
    _wcSwym: _wcSwym,
    reducedMetafields: reducedMetafields,
    _usfGetFacetTitleTran,
    _usfGetFacetValueLabelTran,
  });
})();
